import _ from 'lodash';
import emiter, { _EVENTS } from '../../../events';
import { _APIS } from 'apis';
import request from 'request';
import {Modal, message} from "antd";
import {DEFAULT_PAGE_INFO} from "../../../consts";

export const useServicePolicyTemplate = () => {

	const searchFormReset = (form: any) => {
		emiter.emit(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.SEARCH, {
      ...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
	};
	const searchFormFinish = (form: any) => {
		emiter.emit(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.SEARCH, {
      ...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
	};

    const search = (params: any) => request.get(_APIS.PRODUCT_PRICE.SERVICE_POLICY.SEARCH, { params });

    const getCityList = () => request.get(_APIS.PRODUCT_PRICE.SERVICE_POLICY.CITY_LIST, { });

    const update = (params: any) => request.post(_APIS.PRODUCT_PRICE.SERVICE_POLICY.EDIT, params);

    const getDetail = (params: any) => request.get(_APIS.PRODUCT_PRICE.SERVICE_POLICY.VIEW, { params });

    const deleteData = (params: any) => request.post(_APIS.PRODUCT_PRICE.SERVICE_POLICY.DELETE, params);

    const add = (params: any) => request.post(_APIS.PRODUCT_PRICE.SERVICE_POLICY.ADD, params);

    const onSearchAction = (load: any) => {
        emiter.on(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.SEARCH, load);
    };

    const tablePagination = (data: any) => {
        emiter.emit(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.SEARCH, data);
    }

    const tableActionEdit = async (data: any) => {
        const res = await getDrawerDetail(data)
        emiter.emit(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.EDIT, {
            ...res,
            drawerInfo: {
                disabled: false,
                title: '编辑'
            }
        });
    }

    const tableActionView = async (data: any) => {
        const res = await getDrawerDetail(data)
        emiter.emit(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.VIEW, {
            ...res,
            drawerInfo: {
                disabled: true,
                title: '查看'
            }
        });
    }

    const tableActionAdd = (data: any) => {
        emiter.emit(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.ADD, {
            ...data,
            drawerInfo: {
                disabled: false,
                title: '新建'
            }
        });
    }


    const getDrawerDetail = async (data: any) => {
        if (data.rule_code) {
            const res = await getDetail({
                rule_code: data.rule_code,
            })
            return res.data
        }
    }

    const drawerSubmit = async (data: any, echoData: any) => {
        if (echoData.rule_code) {
            await update({
                ...data,
                rule_code: echoData.rule_code
            })
        } else {
            await add(data)
        }
        message.success('操作成功');
        emiter.emit(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.SEARCH, {
        });
    }

    const getRelatedGoods = (params: any) => {
        if (params.status === undefined || params.status === '') {
            params.status = -1
        }
        if (params.veh_num_type === undefined || params.veh_num_type === '') {
            params.veh_num_type = -1
        }
        return request.post(_APIS.PRODUCT_PRICE.CAR_MODEL_PRICE.SEARCH,  params)
    };

    const deleteItem = async (data: any) => {
        const { confirm } = Modal;
        const res = await getRelatedGoods({
            rule_code: data.rule_code,
            rule_type: 4,
            page: 1,
            page_size: 1000,
        })
        const total = res?.data?.total
        if (total) {
            message.error('请先解绑应用的车型商品')
        } else {
            confirm({
                title: '确认删除该条预定规则?',
                content: '',
                okText: '确认',
			    cancelText: '取消',
                onOk: async () => {
                    await deleteData({
                        rule_code: data.rule_code,
                    })
                    message.success('操作成功');
                    emiter.emit(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.SEARCH, {

                    });
                },
                onCancel() {
                },
            });

        }
    }

    const openModel = async (data: any) => {
        const res = await getRelatedGoods({
            rule_code: data.rule_code,
            rule_type: 4,
            page: 1,
            page_size: 10000,
        })
        const list = res?.data?.list || []
        if (list.length === 0) {
            message.warning('无关联商品');
        } else {
            emiter.emit(_EVENTS.PRODUCT_PRICE.SERVICE_POLICY.OPEN_MODEL, list || []);
        }
    }

    const getInitData = (data: any) => {
        const { rule_code, name, form_data } = data
        return { rule_code, name, ...JSON.parse(form_data)}
    }

    const getSubmitData = (data: any, enums: any) => {
        console.log('mainForm.getFieldsValue:', data)
        const { name } = data
        const formDataKeys = [
            'policy_limit',
            'mile_limit',
            'pre_pickup',
            'delay_pickup',
            'pre_return',
            'renewal',
            'delay_return',
            'pickup_material',
            'city_traffic_limit',
            'drive_area_limit',
            'oil_electric_fee',
            'goods_loss',
            'illegal_deposit',
            'road_assist',
            'home_pickup_fee',
            'force_return_fee',
            'etc_fee',
            'clean_fee',
            'invoice_desc',
        ]
        const submitData: any = {
            name,
            form_data: JSON.stringify(_.pick(data, formDataKeys)),
            c_data: {}
        }
        // formData to cData
        _.map(data, (val: any, key: string) => {
            if (key === 'mile_limit') {
                if (val[1] && val[1] !== '不限制') {
                    return submitData.c_data[key] = {
                        is_limit: 0,
                        desc: val.join('')
                    }
                }

                submitData.c_data[key] = {
                    is_limit: 1,
                    desc: val.slice(0,2).join('')
                }
            }
            else if (key === 'pickup_material') {
                submitData.c_data[key] = _.pick(data[key], ['id_card_left', 'driver_license_left', 'driver_license_age'])
            }
            else if (key === 'drive_area_limit') {
                const options = enums['is_limit']
                const valueArr = data[key].text1
                const selectItem = options?.find?.((item: any) => {
                    return valueArr[1] === item.key
                })
                let res = ''
                //  逻辑处理
                const copyArr = [valueArr?.[0], valueArr?.[1]]
                if (!valueArr?.[3] || valueArr?.[3]?.length === 0 ) {

                } else {
                    copyArr.push(valueArr[2], valueArr[3])
                }
                if (!valueArr?.[5] || valueArr?.[5]?.length === 0 ) {

                } else {
                    copyArr.push(valueArr[4], valueArr[5])
                }
                copyArr.forEach((item: any, index: number) => {
                    if (index === 1) {
                        res += selectItem.value
                    } else if (index === 2 || index === 4) {
                        res += `，${item}`

                    } else if (index === 3 || index === 5) {
                        if (item.length > 0) {
                            const list = item.map((i: any) => {
                                const arr = ['北京市', '天津市', '上海市', '重庆市']
                                if (arr.includes(i?.[1])) {
                                    return i?.[1]
                                } else {
                                    return i.join('-')
                                }
                            })
                            res += `${list.join('、')}`
                        }
                    } else {
                        res += res ? `${item}` : item
                    }
                })
                submitData.c_data[key] = res
            }
            else if (_.includes(formDataKeys, key)) {
                _.map(data[key], val => {
                    submitData.c_data[key] = `${submitData.c_data[key] || ''}${_.isArray(val) ? val.join('') : val}\n`
                })
            }
        })

        console.log('submitData:', submitData)
        return submitData
    }


    return {
        searchFormReset,
        searchFormFinish,
        search,
        update,
        getDetail,
        deleteData,
        add,
        openModel,
        onSearchAction,
        tablePagination,
        tableActionEdit,
        tableActionView,
        tableActionAdd,
        getDrawerDetail,
        drawerSubmit,
        deleteItem,
        getInitData,
        getSubmitData,
        getCityList,
    }
};
